export default __webpack_public_path__ + "static/media/cs.9ecdb26a.md";